export default function isJson(str) {
  try {
    JSON.parse(str);
  } catch (_e) {
    return false;
  }
  return true;
}
